import { StringUtil } from '@nomidio/common';

export enum InvitationStatus {
  Open = 'OPEN',
  Accepted = 'ACCEPTED',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Linking = 'LINKING',
  Linked = 'LINKED',
}

export function InvitationStatusPresentation(status: InvitationStatus): string {
  switch (status) {
    case InvitationStatus.Open:
    case InvitationStatus.Accepted:
    case InvitationStatus.Completed:
    case InvitationStatus.Expired:
    case InvitationStatus.Linking:
    case InvitationStatus.Linked:
      return StringUtil.toPresentationFormat(status);
    default:
      console.warn(`Unrecognised Invitation status '${status}' requested for presentation`);
      return StringUtil.toPresentationFormat(status);
  }
}
